<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title font-weight-bold" id="exampleModalLabel1">
      Crear Usuario
    </h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      mat-dialog-close
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="usuarioForm">
      <div class="row">
        <div class="col-12 col-md-6">
          <mat-form-field style="width: 100%;">
            <mat-label>Correo</mat-label>
            <input
              type="text"
              formControlName="correo"
              matInput
              placeholder="Ingrese su correo"
            />
            <mat-error *ngIf="usuarioForm.get('correo').hasError('required')"
              >El correo es <strong>requerido</strong></mat-error
            >
            <mat-error *ngIf="usuarioForm.get('correo').hasError('email')"
              >El correo es <strong>invalido</strong></mat-error
            >
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <mat-form-field style="width: 100%;">
            <mat-label>Clave</mat-label>
            <input
              type="password"
              formControlName="clave"
              matInput
              placeholder="Ingrese su clave"
            />
            <mat-error *ngIf="usuarioForm.get('clave').hasError('required')"
              >La clave es <strong>requerida</strong></mat-error
            >
            <mat-error *ngIf="usuarioForm.get('clave').hasError('minlength')"
              >La clave debe tener al menos
              <strong>8 caracteres</strong></mat-error
            >
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <mat-form-field style="width: 100%;">
            <mat-label>Nombre</mat-label>
            <input
              type="text"
              formControlName="nombre"
              matInput
              placeholder="Ingrese su nombre"
            />
            <mat-error *ngIf="usuarioForm.get('nombre').hasError('required')"
              >El nombre es <strong>requerido</strong></mat-error
            >
            <mat-error *ngIf="usuarioForm.get('nombre').hasError('pattern')"
              >El nombre es <strong>invalido</strong></mat-error
            >
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <mat-form-field style="width: 100%;">
            <mat-label>Apellido</mat-label>
            <input
              type="text"
              formControlName="apellido"
              matInput
              placeholder="Ingrese su apellido"
            />
            <mat-error *ngIf="usuarioForm.get('apellido').hasError('required')"
              >El apellido es <strong>requerido</strong></mat-error
            >
            <mat-error *ngIf="usuarioForm.get('apellido').hasError('pattern')"
              >El apellido es <strong>invalido</strong></mat-error
            >
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <mat-form-field style="width: 100%;">
            <mat-label>Teléfono</mat-label>
            <input
              type="text"
              formControlName="telefono"
              matInput
              placeholder="Ingrese su numero de telefono"
            />
            <mat-error *ngIf="usuarioForm.get('telefono').hasError('required')"
              >El telefono es <strong>requerido</strong></mat-error
            >
            <mat-error *ngIf="usuarioForm.get('telefono').hasError('pattern')"
              >El telefono es <strong>invalido</strong></mat-error
            >
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6">
          <mat-form-field class="custom-select-form" style="width: 100%;">
            <mat-label>Tipo de documento</mat-label>
            <mat-select formControlName="tipo_documento">
              <div *ngFor="let i of tipo_docs">
                <mat-option [value]="i.name">
                  {{i.name}}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6">
          <mat-form-field style="width: 100%;">
            <mat-label>Documento</mat-label>
            <input
              type="text"
              formControlName="documento"
              matInput
              placeholder="Ingrese su documento"
            />
            <mat-error *ngIf="usuarioForm.get('documento').hasError('required')"
              >El documento es <strong>requerido</strong></mat-error
            >
            <mat-error *ngIf="usuarioForm.get('documento').hasError('pattern')"
              >El documento es <strong>invalido</strong></mat-error
            >
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <mat-form-field style="width: 100%;">
            <mat-label>Nombre del Equipo</mat-label>
            <input
              type="text"
              formControlName="nombre_equipo"
              matInput
              placeholder="Ingrese el nombre del equipo"
            />
            <mat-error
              *ngIf="usuarioForm.get('nombre_equipo').hasError('required')"
              >El nombre del equipo es <strong>requerido</strong></mat-error
            >
            <mat-error
              *ngIf="usuarioForm.get('nombre_equipo').hasError('pattern')"
              >El nombre del equipo es <strong>invalido</strong></mat-error
            >
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <mat-form-field style="width: 100%;">
            <mat-label>NM</mat-label>
            <input
              type="text"
              formControlName="nm"
              matInput
              placeholder="Ingrese su NM"
            />
            <mat-error *ngIf="usuarioForm.get('nm').hasError('required')"
              >El NM es <strong>requerido</strong></mat-error
            >
            <mat-error *ngIf="usuarioForm.get('nm').hasError('pattern')"
              >El NM es <strong>invalido</strong></mat-error
            >
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <mat-form-field class="custom-select-form" style="width: 100%;">
            <mat-label>Rol</mat-label>
            <mat-select formControlName="id_roles">
              <mat-option *ngFor="let rol of roles" [value]="rol.id_roles">
                {{ rol.nombre }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-6">
          <mat-form-field class="custom-select-form" style="width: 100%;">
            <mat-label>Grupo</mat-label>
            <mat-select formControlName="id_grupos">
              <mat-option
                *ngFor="let grupo of grupos"
                [value]="grupo.id_grupos"
              >
                {{ grupo.nombre }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <button
        (click)="save()"
        class="btn btn-info waves-effect float-right"
        [disabled]="usuarioForm.status != 'VALID'"
      >
      <i class="far fa-save"></i>
        Guardar
      </button>
    </form>
  </div>
</div>
